import React from 'react';
import NavBar from '../components/Navbar/NavBar';
import Footer from '../components/Footer';
import { useDocTitle } from '../components/CustomHook';

const EmailList = () => {
  useDocTitle('Join Our Email List');
  return (
    <>
      <NavBar />
      <div className="py-16 px-4">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold text-blue-900 mb-4">Join Our Email List</h1>
          <p className="text-gray-700">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer in luctus nunc. Nam
            tincidunt, magna eu tempus convallis, risus nibh ullamcorper dui, vitae facilisis libero
            dui vitae arcu.
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default EmailList;
